import { useMantineTheme } from '@mantine/core';

export const useGroupColors = () => {
  const { colors: themeColorObject } = useMantineTheme();
  return Object.entries(themeColorObject)
    .filter(
      ([key]) =>
        !key.startsWith('blackroom') && !['white', 'dark'].includes(key),
    )
    .map(([, colors]) => colors[7]);
};
